// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Added v7 — see `ChannelModifier.schema_version`.
 *
 * How an expected step's observed message must agree with the payload the
 * modifier sent.
 *   `SAME_POSITION` (0)          — the default and the pre-v7 behavior: when both the
 *                                  observed message and the payload carry a position,
 *                                  they must be equal. A message with no position
 *                                  therefore matches any position.
 *   `ANY_POSITION` (1)           — position is ignored: one shared confirmation input.
 *   `SAME_POSITION_AND_LIFT` (2) — as `SAME_POSITION`, and the observed message's lift
 *                                  must also be the source message's lift.
 */
export enum SequenceStepScope {
  SAME_POSITION = 0,
  ANY_POSITION = 1,
  SAME_POSITION_AND_LIFT = 2,
}
